import { z } from "zod";

import { sitePhotoOcrResultStatusSchema } from "@/types/backoffice/dto/photo/site-photo-dto.ts";

const siteDocumentIdSchema = z.number().brand<"SiteDocumentId">();

export type TSiteDocumentId = z.infer<typeof siteDocumentIdSchema>;

export enum ESiteDocumentType {
  ESC_INVOICE = "ESC_INVOICE",
  ESC_ESTIMATE_PAPER_PHOTO = "ESC_ESTIMATE_PAPER_PHOTO",
  ELECTRONIC_SEALED_DOCUMENT = "ELECTRONIC_SEALED_DOCUMENT",
  YOUSIGN_AUDIT_TRAIL = "YOUSIGN_AUDIT_TRAIL",
  ESC_QUOTE = "ESC_QUOTE",
  INSTALLATION_SHEET = "INSTALLATION_SHEET",
  INSTALLATION_SHEET_BASIC = "INSTALLATION_SHEET_BASIC",
  ESC_SWORN_STATEMENT = "ESC_SWORN_STATEMENT",
  TAX_REDUCTION_STATEMENT = "TAX_REDUCTION_STATEMENT",
  ELECTRICITY_BILL = "ELECTRICITY_BILL",
  TRANSFER_SALES = "TRANSFER_SALES",
  TRANSFER_PROVISION = "TRANSFER_PROVISION",
  INTERVENTION_SALES = "INTERVENTION_SALES",
  INTERVENTION_PROVISION = "INTERVENTION_PROVISION",
  ESC_CREDIT_NOTE = "ESC_CREDIT_NOTE",
  ESTIMATE_ESC_STATEMENT = "ESTIMATE_ESC_STATEMENT",
  ESC_CUSTOMER_SERVICE_CERTIFICATE = "ESC_CUSTOMER_SERVICE_CERTIFICATE",
  ELECTRICITY_BILL_PHOTO_PDF = "ELECTRICITY_BILL_PHOTO_PDF",
}

const siteDocumentTypeSchema = z.nativeEnum(ESiteDocumentType);

export const siteDocumentTypeDtoSchema = z.object({
  filename: z.string(),
  id: z.number(),
  mailable: z.boolean(),
  mediaType: z.unknown().nullable(), // Idk, we probably do not really care about this
  name: siteDocumentTypeSchema,
});

export const siteDocumentDtoSchema = z.object({
  id: siteDocumentIdSchema,
  type: siteDocumentTypeDtoSchema,
  filename: z.string(),
  size: z.number(),
  url: z.string(),
  creationDateTime: z.coerce.date(),
  origin: z.string(),
  ocrResultStatus: sitePhotoOcrResultStatusSchema.nullish(),
});

export type TSiteDocumentDto = z.infer<typeof siteDocumentDtoSchema>;

export const siteDocumentsDtoSchema = z.object({
  documents: z.array(siteDocumentDtoSchema),
});
